import { Modal, Table } from "antd";
import dayjs from "dayjs";
import React from "react";
import { FaTimes } from "react-icons/fa";

const ModalLogComponent = ({
  bodyStyle = null,
  visible = true,
  setVisible,
  width = 520,
  destroyOnClose = true,
  log,
}) => {
  const handleClose = () => {
    setVisible(false);
  };
  const columns = [
    {
      title: "ครั้งที่",
      align: "center",
      width: 50,
      render: (_, __, index) => <>{index + 1}</>,
    },
    {
      title: "วันที่",
      align: "center",
      key: "create_date",
      dataIndex: "create_date",
      width: 150,
      render: (text) => dayjs(text).format("DD-MM-YYYY HH:mm น."),
    },
    {
      title: "รายละเอียด",
      key: "description",
      dataIndex: "description",
      render: (text) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {text || "-"}
        </div>
      ),
    },
  ];
  return (
    <Modal
      footer={false}
      visible={visible}
      closeIcon={<FaTimes />}
      onCancel={handleClose}
      width={width}
      maskClosable={false}
      destroyOnClose={destroyOnClose}
    >
      <h3 className="text-center">รายละเอียด</h3>
      <div
        style={{ ...bodyStyle, marginRight: "-14px", paddingRight: "14px" }}
        className="custom-scroll"
      >
        <Table
          columns={columns}
          rowKey="id"
          bordered
          dataSource={log || []}
          size="small"
          pagination={false}
        />
      </div>
    </Modal>
  );
};

export default ModalLogComponent;
